import { render, staticRenderFns } from "./TextbookStatistics.vue?vue&type=template&id=a29779de&scoped=true"
import script from "./TextbookStatistics.vue?vue&type=script&lang=js"
export * from "./TextbookStatistics.vue?vue&type=script&lang=js"
import style0 from "./TextbookStatistics.vue?vue&type=style&index=0&id=a29779de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29779de",
  null
  
)

export default component.exports